import React from 'react';

import FinancialFreedomLight from '../../images/financial-freedom-light.svg';
import FinancialFreedomDark from '../../images/financial-freedom-dark.svg';
import BecomeAStarLight from '../../images/become-a-star-illustration-light.svg';
import BecomeAStarDark from '../../images/become-a-star-illustration-dark.svg';
import PrivacyIllustrationLight from '../../images/privacy-illustration-light.svg';
import PrivacyIllustrationDark from '../../images/privacy-illustration-dark.svg';

const Features = () => (
  <section className="pb-12 bg-gray-50 dark:bg-gray-800 sm:pb-16 lg:pb-20">
    <div className="px-6 mx-auto max-w-7xl sm:px-12 lg:px-16 xl:px-20">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-sm font-bold tracking-widest uppercase text-secondary-500 dark:text-secondary-400">
          Building a one app ecosystem
        </h2>
        <p className="mt-6 text-2xl font-bold text-gray-900 dark:text-white sm:text-3xl lg:text-4xl">
          The best of creator monetization meets the goodness of Social Media
        </p>
      </div>

      <div className="grid grid-cols-1 mt-12 text-center gap-y-12 lg:grid-cols-3 lg:mt-20 sm:mt-16 gap-x-16">
        <div className="lg:order-2">
          <img className="block w-48 h-48 mx-auto dark:hidden" src={FinancialFreedomLight} alt="Financial Freedom" />
          <img className="hidden w-48 h-48 mx-auto dark:block" src={FinancialFreedomDark} alt="Financial Freedom" />
          <h3 className="mt-6 text-xl font-bold text-gray-900 dark:text-white lg:text-2xl">
            Gain Financial Freedom
          </h3>
          <p className="mt-3 text-base font-medium text-gray-500 dark:text-gray-400">
            Make a living doing what you love, creating authentic content
          </p>
        </div>

        <div className="lg:order-3">
          <img className="block w-48 h-48 mx-auto dark:hidden" src={BecomeAStarLight} alt="Become a Star" />
          <img className="hidden w-48 h-48 mx-auto dark:block" src={BecomeAStarDark} alt="Become a Star" />
          <h3 className="mt-6 text-xl font-bold text-gray-900 dark:text-white lg:text-2xl">
            Become a Star!
          </h3>
          <p className="mt-3 text-base font-medium text-gray-500 dark:text-gray-400">
            Fan communities share, interact & create content to get recognized!
          </p>
        </div>

        <div className="lg:order-1">
          <img className="block w-48 h-48 mx-auto dark:hidden" src={PrivacyIllustrationLight} alt="No Social Dilemma" />
          <img className="hidden w-48 h-48 mx-auto dark:block" src={PrivacyIllustrationDark} alt="No Social Dilemma" />
          <h3 className="mt-6 text-xl font-bold text-gray-900 dark:text-white lg:text-2xl">
            No Social Dilemma
          </h3>
          <p className="mt-3 text-base font-medium text-gray-500 dark:text-gray-400">
            Privacy-first platform with no ads and more control over the content you see
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Features;
